import BaseButton from "components/baseButton/baseButton";
import { t } from "i18next";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { confirmModal, declineModal } from "redux/reducers/modalReducer";
import { executeAxiosRequestWithRefresh } from "redux/services";
import { useAppDispatch } from "redux/store";
import { StringResources } from "utils/language/languageResource";
import { PageTypeEnum } from "utils/reportDefinitions";
import { ModalTypeEnum } from "utils/enums";
import "./disableApiKeyModal.scss";
import BaseBanner from "components/baseBanner/baseBanner";

interface IDisableApiKeyModalProps {
    title: string;
    actionButtonText: string;

    data: {
        apiKeyId: number;
        keyName: string;
        partnerAgreementNumbers?: string[];
    };
}

const DisableApiKeyModal = ({ title, actionButtonText, data }: IDisableApiKeyModalProps) => {
    const dispatch = useAppDispatch();

    const handleDisable = async () => {
        try {
            await executeAxiosRequestWithRefresh({
                url: `/api/users/disable-api-key`,
                method: "POST",
                data: {
                    apiKeyId: data.apiKeyId,
                },
            });
            toast.success(t(StringResources.pages[PageTypeEnum.ApiKeys].disabledKeySuccess) as string);
            dispatch(confirmModal({ modalType: ModalTypeEnum.DisableApiKey }));
        } catch (error) {
            toast.error(t(StringResources.pages[PageTypeEnum.ApiKeys].disabledKeyError) as string);
        }
    };

    const handleClose = () => {
        dispatch(declineModal({ modalType: ModalTypeEnum.DisableApiKey }));
    };

    return (
        <Modal show={true} onHide={handleClose} className="disable-api-key" dialogClassName="base-modal" size="sm">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <BaseBanner
                    type="info"
                    text={
                        t(StringResources.modal.apiKeys.disableKeyMessageWithAgreements, {
                            keyName: data.keyName,
                            partnerAgreementNumbers:
                                data.partnerAgreementNumbers && data.partnerAgreementNumbers.length > 0
                                    ? data.partnerAgreementNumbers.join(", ")
                                    : "-",
                        }) as string
                    }
                />
            </Modal.Body>
            <Modal.Footer>
                <BaseButton
                    handleClick={handleClose}
                    text={t(StringResources.modal.cancel) as string}
                    styleType="line"
                />
                <BaseButton handleClick={handleDisable} text={actionButtonText} styleType="solid" />
            </Modal.Footer>
        </Modal>
    );
};

export default DisableApiKeyModal;
